import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import $ from 'jquery';
import DailyTtsUsageReport from './DailyTtsUsageReport';
import MonthlyTtsUsageReport from './MonthlyTtsUsageReport';
import WeeklyTtsUsageReport from './WeeklyTtsUsageReport';

class TtsReportTab extends Component {
    componentDidMount() {
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/platform/cloud-tts/reports";
            var path1 = window.origin + "/platform/cloud-tts/reports/";
            if (currentPath === path || currentPath === path1) {
                $("#akshar-daily-report").addClass('active');
            } else if (currentPath.includes("/cloud-tts/reports/monthly-reports")) {
                $("#akshar-monthly-report").addClass('active');
            } else if (currentPath.includes("/cloud-tts/reports/weekly-reports")) {
                $("#akshar-weekly-report").addClass('active');
            }
            else {
                $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
            }
            $("#akshar-daily-report,#akshar-monthly-report, #akshar-weekly-report")
                .on("click", function () {
                    $("#akshar-daily-report,#akshar-monthly-report, #akshar-weekly-report")
                        .removeClass('active');
                    localStorage.setItem("last-akshar-report-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (
            <Router basename={window.contextPath}>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5">
                                        <h1 className="m-0 page-title">Reports </h1>
                                        {/* <h6 className="taglineTxt">Build Interact &amp; Distribute</h6> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid" style={{ marginLeft: '10px' }}>
                            <div className="border-bottom"></div>
                            {/* Nav tabs */}
                            <div className="tab-class" >
                                <ul className="nav nav-tabs border-bottom navCluster">
                                    <Link to="/cloud-tts/reports" className="nav-item" data-toggle="tab"
                                        style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="akshar-daily-report">Daily Reports</li>
                                    </Link>
                                    <Link to="/cloud-tts/reports/weekly-reports" className="nav-item" data-toggle="tab"
                                        style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="akshar-weekly-report">Weekly Reports</li>
                                    </Link>
                                    <Link to="/cloud-tts/reports/monthly-reports" className="nav-item" data-toggle="tab"
                                        style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="akshar-monthly-report">Monthly Reports</li>
                                    </Link>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/cloud-tts/reports/weekly-reports" component={WeeklyTtsUsageReport}></Route>
                        <Route path="/cloud-tts/reports/monthly-reports" component={MonthlyTtsUsageReport}></Route>
                        <Route path="/cloud-tts/reports" component={DailyTtsUsageReport}></Route>
                    </Switch>
                </div>
            </Router>

        );
    }
}
export default TtsReportTab;



// WEBPACK FOOTER //
// ./src/ttsUi/reports/TtsReportTab.js